import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import StepinVconsole17 from './StepinVconsole17.vue' 

declareVconsoleComponent('stepinVconsole17', StepinVconsole17, 'stepin:vconsole17');
 
import StepinVconsole17Action from './StepinVconsole17Action.vue' 

declareVconsoleComponent('stepinVconsole17Action', StepinVconsole17Action, 'stepin:vconsole17:action');  